
import React, { useState, useEffect } from 'react';
import Navbar from "./Router";
import setBodyColor from './js/setBodyColor';
import setButtonColor from './js/setButtonColor';
import { Pulsar } from 'ldrs/react';
import './css/pulsar.css';

const App = () => {
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
          setLoading(false);
      }, 2000);

      return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isLoading) {
        // slight delay so the fade-in animation starts after content appears
        setTimeout(() => {
            document.documentElement.classList.add('show-stylized');
        }, 100);
    }

    return () => {
        document.documentElement.classList.remove('show-stylized');
    };
  }, [isLoading]);

  setBodyColor({ background: '#1E293B', isHome: true });
  setButtonColor({ borderColor: "rgba(148,163,184,.6)", color: "rgb(51 65 85/var(--tw-text-opacity,1))"});

  return (
    <div>
      {
        isLoading ? <div className="outer-loader"><Pulsar
            size="175"
            speed="4.8"
            color="#fff"
          /></div> : (
          <main className="loader-fade-in">
              <Navbar />
              <div className="container-home">
                <div className="circle"></div>
                <div className="heading">
                  <h1>Manik Studio</h1>
                  <h3>Technical partner for founders and businesses turning concepts into products</h3>
                </div>
                {/* <p>web design & development&nbsp;&nbsp;/&nbsp;&nbsp;custom app development&nbsp;&nbsp;/ &nbsp;&nbsp;technical consulting</p> */}
              </div>
          </main>
        )
      }
    </div>
  );
};


export default App;